import React from "react";
import { Select } from "antd";

import { useGetCategoryList } from "../../DashboardPages/Access/queries";

const AccessCategory = (props) => {
    const { data: accessResources = [], isLoading: isLoadingAccess } = useGetCategoryList();
    return (
        <Select
            {...props}
            loading={isLoadingAccess}
            getPopupContainer={(triggerNode) => triggerNode.parentElement}
            allowClear
        >
            {accessResources?.map((data) => {
                return (
                    <Select.Option key={data?.id} value={data.id}>
                        {data?.name}
                    </Select.Option>
                );
            })}
        </Select>
    );
};
export default AccessCategory;
